import React from 'react';

import { ExpandableTable } from '../../../components/expandable-table';
import { createCommonSubmissionCardsTableColumns } from '../commons/columns';
import { getSubmissionCards } from '../commons/utils';

const commonSubmissionCardsTableColumns = createCommonSubmissionCardsTableColumns();

export function SubmissionCardsTable(props) {
  const { allSubmissionsCards, submission } = props;

  const cards = getSubmissionCards(submission, allSubmissionsCards);

  return (
    <ExpandableTable
      columns={commonSubmissionCardsTableColumns}
      rows={cards}
    />
  );
}
